import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// types
import { RobotRegFormType } from '../../types/RobotRegFormType';

interface RobotrobotRegFormState {
    robotRegFormloading: boolean;
    robotRegFormSuccess: boolean | null;
    robotRegFormError: string | null;
}

const initialState: RobotrobotRegFormState = {
    robotRegFormloading: false,
    robotRegFormSuccess: null,
    robotRegFormError: null,
};

const robotrobotRegFormReducer = createSlice({
    name: 'robotrobotRegForm',
    initialState,
    reducers: {
        postRobotRegForm: (state, action: PayloadAction<RobotRegFormType>) => {
            state.robotRegFormloading = true;
        },
        postRobotRegFormSuccess: (state, action: PayloadAction<string>) => {
            state.robotRegFormloading = false;
            state.robotRegFormSuccess = true;
        },
        postRobotRegFormFailure: (state, action: PayloadAction<string>) => {
            state.robotRegFormloading = false;
            state.robotRegFormError = action.payload;
        },
        resetRobotRegForm: (state) => {
            return initialState;
        },
    },
});

export const {
    postRobotRegForm,
    postRobotRegFormSuccess,
    postRobotRegFormFailure,
    resetRobotRegForm,
} = robotrobotRegFormReducer.actions;
export default robotrobotRegFormReducer.reducer;